module.exports.run = obj => !Object.keys(obj).length;